// Weigh-ins carry two times: `date` is the day the animal was weighed
// (YYYY-MM-DD) and `created_at` is when the record was entered. Order and
// display by the weigh day, so a backdated or late-entered weigh-in lands
// where it belongs. Ties within the same day are broken by `_id` (a Mongo
// ObjectId, so its hex string sorts in insertion order), not created_at:
// WhatsApp lot-code weigh-ins are saved without a created_at, and the order
// has to be total or "latest" depends on who is asking (Trello gF2gHTr6).

export const weighDay = (w) => (w?.date || '').slice(0, 10);

// Oldest first. Use with .sort(), or `compareWeighins(a, b) > 0` for "a is later".
export const compareWeighins = (a, b) =>
  weighDay(a).localeCompare(weighDay(b)) ||
  String(a._id || '').localeCompare(String(b._id || ''));

// DD/MM/YY of the weigh day.
export const formatWeighDay = (w) => {
  const day = weighDay(w);
  if (!day) return '—';
  const [y, m, d] = day.split('-');
  return `${d}/${m}/${y.slice(2)}`;
};
